import { whyChooseItems } from "@/mocks/whyChoose";
import ScrollReveal from "@/components/base/ScrollReveal";

export default function WhyChoose() {
  return (
    <section id="porque-escolher" className="relative w-full py-20 md:py-28 bg-organic-warm overflow-hidden">
      <div className="relative w-full px-4 sm:px-6 md:px-10 lg:px-16 max-w-7xl mx-auto">
        <ScrollReveal className="text-center mb-14">
          <span className="inline-block text-xs font-semibold uppercase tracking-[0.2em] text-primary-600 mb-4">
            Por que a Big Mania
          </span>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-heading font-bold text-foreground-950 leading-tight mb-4">
            A escolha de quem{" "}
            <span className="text-primary-600">entende de sabor</span>
          </h2>
          <p className="text-foreground-600 max-w-xl mx-auto text-base md:text-lg">
            Descubra por que milhares de clientes em Fortaleza confiam na Big Mania para seus sanduiches e eventos.
          </p>
        </ScrollReveal>

        <ScrollReveal direction="up" delay={0.15} staggerChildren staggerDelay={0.08}>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
            {whyChooseItems.map((item, idx) => {
              const colorMap: Record<string, { bg: string; icon: string; hover: string }> = {
                primary: { bg: "bg-primary-100", icon: "text-primary-600", hover: "hover:border-primary-300/50" },
                accent: { bg: "bg-accent-100", icon: "text-accent-600", hover: "hover:border-accent-300/50" },
                secondary: { bg: "bg-secondary-100", icon: "text-secondary-600", hover: "hover:border-secondary-300/50" },
              };
              const colors = colorMap[item.color] || colorMap.primary;

              return (
                <div
                  key={idx}
                  className={`group p-6 md:p-7 rounded-2xl bg-background-50/80 border border-background-200/40 ${colors.hover} card-glow transition-all duration-500 hover:-translate-y-1.5`}
                >
                  <div className={`w-12 h-12 rounded-xl ${colors.bg} flex items-center justify-center mb-5 transition-transform duration-300 group-hover:scale-110`}>
                    <i className={`${item.icon} ${colors.icon} text-xl`}></i>
                  </div>
                  <h3 className="text-lg font-heading font-semibold text-foreground-950 mb-2">
                    {item.title}
                  </h3>
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    {item.description}
                  </p>
                </div>
              );
            })}
          </div>
        </ScrollReveal>
      </div>
    </section>
  );
}